import { render, staticRenderFns } from "./MessageSearchBoxV2.vue?vue&type=template&id=015efb0a&scoped=true"
import script from "./MessageSearchBoxV2.vue?vue&type=script&lang=js"
export * from "./MessageSearchBoxV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015efb0a",
  null
  
)

export default component.exports